import React from 'react';  
import Sidebar from '../component/Sidebar';
import Topbar from '../component/Topbar';
 

function About() {
 

console.log(localStorage.getItem("user.id"));


  return (

    <>
<Topbar/>
 <Sidebar/>
 

    <main class="main-wrapper">
         <div class="main-content">
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div class="breadcrumb-title pe-3">Dashboard</div>
        <div class="ps-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
              <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Starter Page</li>
            </ol>
          </nav>
        </div>

            </div>


            <div class="col-12 col-lg-6 col-xl-3">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-center gap-3 flex-grow-1">
                  <div class="wh-48 d-flex align-items-center bg-primary bg-opacity-10 justify-content-center rounded-circle">
                    <span class="material-icons-outlined text-primary">shopping_cart</span>
                  </div>
                  <div class="">
                    <h5 class="mb-0">6</h5>
                    <p class="mb-0">Active Services</p>
                  </div>
                </div> 
              </div> 
            </div>
          </div>
        </div>


         </div>
    </main>
    

        

    </>
  );
}

export default About;
